import { render, staticRenderFns } from "./yhqGiftsAction.vue?vue&type=template&id=58695d9e&scoped=true"
import script from "./yhqGiftsAction.vue?vue&type=script&lang=js"
export * from "./yhqGiftsAction.vue?vue&type=script&lang=js"
import style0 from "./yhqGiftsAction.vue?vue&type=style&index=0&id=58695d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58695d9e",
  null
  
)

export default component.exports